import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-editable-textarea',
  templateUrl: './editable-textarea.component.html',
  styleUrls: ['./editable-textarea.component.scss']
})
export class EditableTextareaComponent implements OnInit, OnChanges {

  // Mínimo ancho basado en el tamaño del placeholder
  minInputWidth: number = 150; // Puedes ajustar este valor según tus necesidades
  @Input() example: boolean = true;
  @Output() textExported = new EventEmitter<any>();
  @Output() allValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  private valid: boolean = false;

  value1: string = '';
  value2: string = '';
  value3: string = '';
  value4: string = '';
  value5: string = '';

  constructor() {

  }

  ngOnInit(): void {
    this.initializeValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['texto'] && !changes['texto'].firstChange) {
      console.log('OnChanges detectado para texto:', changes['texto'].currentValue);
      this.initializeValues();
    }
  }

  // Setter para detectar cambios en la propiedad texto
  @Input() set texto(value: string) {
    console.log('Setter texto llamado con valor:', value);
    console.log('Valor anterior:', this._texto);
    console.log('¿Son diferentes?', this._texto !== value);
    this._texto = value;
    this.initializeValues();
  }

  get texto(): string {
    return this._texto;
  }

  private _texto: string = '';

  private initializeValues() {
    console.log('Inicializando valores con texto:', this.texto);

    if (!this.texto) {
      this.setDefaultValues();
      return;
    }

    // Expresión regular para buscar texto entre comillas
    const regex = /"([^"]*)"/g;

    // Array para almacenar los valores entre comillas
    const valores: string[] = [];
    let match: RegExpExecArray | null;

    // Itera sobre las coincidencias y almacena los valores
    while ((match = regex.exec(this.texto)) !== null) {
      valores.push(match[1]);
    }

    // Asigna los valores a las variables value1, value2, value3, value4
    this.value1 = valores[0] || '';
    this.value2 = valores[1] || '';
    this.value3 = valores[2] || '';
    this.value4 = valores[3] || '';
    this.value5 = valores[4] || '';

    console.log('Valores inicializados:', {
      value1: this.value1,
      value2: this.value2,
      value3: this.value3,
      value4: this.value4,
      value5: this.value5
    });

    this.setDefaultValues();
  }

  private setDefaultValues() {
    if(!this.value1){
      this.value1 = 'ESCRIBA AQUI EL TITULO CORTO DEL PROYECTO'
    }
    if(!this.value2){
      this.value2 = 'ESCRIBA AQUI EL NOMBRE DE LA ENTIDAD'
    }
    if(!this.value3){
      this.value3 = 'ESCRIBA AQUI EL OBJETIVO RESUMIDO DEL PROYECTO'
    }
    if(!this.value4){
      this.value4 = 'ESCRIBA AQUI EL AÑO DE INICIO DEL PROYECTO'
    }
    if(!this.value5){
      this.value5 = 'ESCRIBA AQUI LOS LOGROS DEL PROYECTO'
    }
  }

  // Método público para reinicializar el componente desde el exterior
  public reinicializar() {
    console.log('Reinicializando editable-textarea con texto:', this.texto);
    this.initializeValues();
  }


  setCursorPosition(element: any, position: number): void {
    const range = document.createRange();
    const selection = window.getSelection();
    let charIndex = 0, node, foundStart = false;

    (function traverseNodes(node) {
      if (node.nodeType === 3) {
        const nextCharIndex = charIndex + node.length;
        if (!foundStart && position >= charIndex && position <= nextCharIndex) {
          range.setStart(node, position - charIndex);
          range.setEnd(node, position - charIndex);
          foundStart = true;
        }
        charIndex = nextCharIndex;
      } else {
        for (let i = 0; i < node.childNodes.length; i++) {
          traverseNodes(node.childNodes[i]);
          if (foundStart) break;
        }
      }
    })(element);

    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }



  onInput(event: any, valueKey: string) {
    // Obtener el valor ingresado y filtrar las comillas dobles
    // const inputValue = event.target.value.replace(/"/g, '');
    // // Convertir el valor a mayúsculas
    // const upperCaseValue = inputValue.toUpperCase();
    // // Asignar el valor convertido a mayúsculas a la propiedad correspondiente
    // this[valueKey] = upperCaseValue;
    // console.log(this[valueKey]);
    // this.exportText();
    const span = event.target;
    const selection = window.getSelection();
    if (selection) {
      const range = selection.getRangeAt(0);
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(span);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      const cursorPosition = preCaretRange.toString().length;

    const element = event.target as HTMLElement;
    let content = element.textContent || '';

    // Elimina las comillas y convierte a mayúsculas
    content = content.replace(/"/g, '');
    
    // Elimina los saltos de línea
    content = content.replace(/\n/g, ' ').replace(/\r/g, '');

    // Reemplaza el contenido del span
    element.textContent = content;

    if (content.trim().length === 0) {
      this.valid = false;
    }

    //Al usar spans se le asigna el valor a las variables de esta forma en vez de ngModel
    switch (valueKey) {
      case 'value1':
        this.value1 = content;
        break;
      case 'value2':
        this.value2 = content;
        break;
      case 'value3':
        this.value3 = content;
        break;
      case 'value4':
        this.value4 = content;
        break;
      case 'value5':
        this.value5 = content;
        break;
      default:
        break;
    };

    if (this.value1.trim().length > 0 &&
      this.value2.trim().length > 0 &&
      this.value3.trim().length > 0 &&
      this.value4.trim().length > 0 &&
      this.value5.trim().length > 0) this.valid = true;

    this.setCursorPosition(span, cursorPosition);
    this.allValid.emit(this.valid);
  }

  
  }


  calculateInputWidth(value: string): number {
    // Obtener el ancho máximo basado en el contenido o el mínimo basado en el placeholder
    const minWidth = this.minInputWidth;
    const textWidth = value ? value.length * 9 : 0; // Multiplicamos por un factor que determine el ancho de cada caracter
    // console.log(value, textWidth)
    return Math.max(minWidth, textWidth);
  }

  onInputBlur(valueKey: string, event: any) {
    // this[valueKey] = event.target.value;
    this[valueKey] = event.target.textContent;
    this.exportText();
  }

  exportText() {
    const text = `"${this.value1}" (Título corto del proyecto) es un proyecto liderado por "${this.value2}" (nombre de la entidad), con el objetivo de "${this.value3}" (poner el objetivo). Desde el (año) "${this.value4}" hemos logrado "${this.value5}"(poner logros con indicadores del proyecto desde que está en ejecución).`;

    if (this.value1.trim().length > 0 &&
      this.value2.trim().length > 0 &&
      this.value3.trim().length > 0 &&
      this.value4.trim().length > 0 &&
      this.value5.trim().length > 0) this.valid = true;

    let datos = {
      // event: {
      target: {
        value: text
      }
      // }
    }

    this.textExported.emit(datos);
    this.allValid.emit(this.valid);
  }

}
